// src/api/registerUser.js
import axios from "axios";
import { toast } from "react-toastify";
import { serverUrl } from "utils/utils";

const loginUser = async (formData) => {
  try {
    const res = await axios.post(`${serverUrl}/user/login`, {
      email: formData.email,
      password: formData.password,
    });
    localStorage.setItem(`userToken`, res.data.token);
    console.log(res.data);
    if (res.data.success) {
      toast.success(res.data.message);
      setTimeout(() => {
        location.reload();
      }, 2000);
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    throw err.response?.data || { error: "Unknown error" };
  }
};

export default loginUser;
